<template>
  <div style="padding: 20px">
    <el-input style="width: 150px" v-model="query.studentName" placeholder="姓名"></el-input>
    <el-select style="width: 150px" v-model="query.type" placeholder="是否转化" class="handle-select mr10">
      <el-option label="转化" :value="1"></el-option>
      <el-option label="未转化" :value="2"></el-option>
    </el-select>
    <el-select style="width: 150px" v-model="query.cityIdList" placeholder="城市" class="handle-select mr10"     multiple
               collapse-tags>
      <el-option
          v-for="(item,index) in regionList" :key="index"
          :label="item.name"
          :value="item.id"></el-option>
    </el-select>
    <select-area  @areaListId="getAreaListId"/>
    <el-date-picker
        v-model="query.yearAndMonth"
        type="month"
        style="width: 170px;"
        value-format="YYYY-MM"
        placeholder="日期选择">
    </el-date-picker>
    <el-button
        type="primary"
        icon="Search"
        style="margin-left: 10px"
        @click="selectList">搜索
    </el-button>

    <el-button
        type="primary"
        style="margin-left: 10px"
        @click="exportTrainee">导出
    </el-button>
    <div>

      <el-table :data="tableData" border style="width: 100%;margin-top: 20px"
                :row-style="{height:54+'px'}"
                :cell-style="{padding:0+'px'}">
        <el-table-column prop="name" label="学员名称" width="180" />
        <el-table-column prop="campusName" show-overflow-tooltip label="校区" width="180">
          <template #default="scope">
            {{scope.row.pro}}-{{scope.row.city}}-{{scope.row.area}}-{{scope.row.campusName}}-{{scope.row.areaFlag}}
          </template>
        </el-table-column>
        <el-table-column prop="coachName" label="教练" width="180" />
        <el-table-column prop="campusName" label="校区" width="180" />
        <el-table-column prop="abnormalInfo" label="试听说明" width="180"/>
        <el-table-column prop="transferCoachName" label="转换人" width="180"/>
        <el-table-column prop="orderId" label="成单id" width="180" />
        <el-table-column prop="conversionTime" label="成单时间" width="180" />
        <el-table-column prop="coursedate" label="试课时间" width="180"/>
        <el-table-column prop="transfer" label="试听说明" width="180"/>
        <el-table-column prop="money" label="转化金额" width="180"/>
        <el-table-column prop="transferSelf" label="是否为本人转化" width="180"/>
      </el-table>
      <div class="pagination">
        <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="query.pageIndex"
            :page-size="query.pageSize"
            :total="query.total"
            @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import SelectArea from "../../components/SelectArea";
import {selectAreaByExpress} from "@/api/area";
import {selectTraineePage,exportTrainee} from "../../api/studentList";
export default {
  name: "Trainee",
  components:{SelectArea},
  data() {
    return {
      query:{
        cityIdList: [],
        areaIdList:[],
        month: null,
        pageIndex: 1,
        pageSize: 10,
        studentName: "",
        yearAndMonth:null,
        type: null,
        year: null,
        flag: 0,
        total:0
      },
      tableData:[],
      regionList: [],
    }
  },
  methods:{
    dateFormat(val) {
      const date = new Date(val);
      const y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      return [y, m];
    },
    handlePageChange(val) {
      this.query.pageIndex = val
      this.selectList();
    },
    selectList(){
      if (this.query.yearAndMonth){
        let list = this.dateFormat(this.query.yearAndMonth);
        this.query.year = list[0];
        this.query.month = list[1];
      }else {
        this.query.year = null;
        this.query.month = null;
      }
      selectTraineePage(this.query).then(val=>{
        if (val.code == 200) {
          this.tableData = val.data.records;
          this.query.total = val.data.total
        } else {
          this.$message.error("获取列表失败！");
        }
      })
    },
    exportTrainee(){
      if (this.query.yearAndMonth){
        let list = this.dateFormat(this.query.yearAndMonth);
        this.query.year = list[0];
        this.query.month = list[1];
      }else {
        this.query.year = null;
        this.query.month = null;
      }
      exportTrainee(this.query).then(val=>{
        if (val.code == 200) {
          this.$message.success("导出中，右上角可查看进度！")
        } else {
          this.$message.error(val.message);
        }
      })
    },
    getAreaListId(val) {
      this.query.areaIdList = val;
    },
  },

  created() {
    this.selectList();

    selectAreaByExpress().then(res => {
      if (res.code === 200) {
        this.regionList = res.data;
        /*if (this.regionList.length>0){
          this.query.cityIdList = [this.regionList[0].id];
          this.selectList();
        }else {
          this.$message.error("无权限查看！");
        }*/
      } else {
        this.$message.error("获取城市数据失败");
      }
    })
  }
}
</script>

<style scoped>

</style>
